<template>
  <RevContentBlock
    :button-label="i18n(translations.buttonLabel)"
    button-variant="secondary"
    class="flex justify-end px-56 py-16"
    :image-props
    :surtitle="i18n(translations.surtitle)"
    :title
    @click="$emit('try-again')"
  />
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevContentBlock } from '@ds/components/ContentBlock'

import translations from './TechnicalIssueBlock.translations'

const i18n = useI18n()

const { title } = defineProps<{ title: string }>()
defineEmits(['try-again'])

const imageProps = {
  alt: '',
  height: 257,
  src: '/img/customer-care/meltedIceCream.svg',
  width: 465,
  style: 'max-height: 465px',
}
</script>
